/**
 * Baisse de prix « récente » : aligné sur le backend (historique_prix, 14 jours).
 * @param {number|null|undefined} chf – montant CHF de la baisse (positif = baisse)
 */
export function hasRecentPriceDropChf(chf) {
  const n = Number(chf)
  return Number.isFinite(n) && n > 0
}

export function formatRecentDropLine(chf) {
  if (!hasRecentPriceDropChf(chf)) return null
  return `Baisse récente (14 j) : −${Math.round(Number(chf)).toLocaleString('fr-CH')} CHF`
}

const MS_PER_DAY = 86400000

/**
 * Dernière baisse enregistrée dans `historique_prix` sur les 14 derniers jours.
 * Attendu : entrées `{ delta, cree_at }` avec delta = nouveau_prix − ancien_prix (négatif = baisse).
 * @param {Array<{ delta?: unknown, cree_at?: string|Date|null }>|null|undefined} rows
 * @returns {number|null} montant CHF de baisse (positif)
 */
export function recentDropChfFromHistoriqueRows(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return null
  let best = null
  let bestTs = -Infinity
  for (const row of rows) {
    const delta = Number(row?.delta)
    if (!Number.isFinite(delta) || delta >= 0) continue
    const at = row?.cree_at != null ? new Date(row.cree_at).getTime() : NaN
    if (!Number.isFinite(at)) continue
    const ageDays = (Date.now() - at) / MS_PER_DAY
    if (ageDays < 0 || ageDays > 14) continue
    const chf = -delta
    if (at >= bestTs) {
      bestTs = at
      best = chf
    }
  }
  return hasRecentPriceDropChf(best) ? best : null
}
